<template>
	<a-loading v-if="!error" :name="$t('loading')" />
	<a-dialog v-else class="survey__error-dialog">
		<div v-if="error" class="survey__error">
			<span>{{ $t("errorLoading") }}</span>
			<a-button class="survey__error-button" @click="reload">{{
				$t("tryAgain")
			}}</a-button>
		</div>
	</a-dialog>
</template>

<script>
import aDialog from "@/components/Dialog";
import aLoading from "@/components/Loading";
import aButton from "@/components/Button";
import survey from "../survey";
import store from "@/store";

export default {
	components: {
		aDialog,
		aLoading,
		aButton
	},
	data() {
		return {
			error: undefined
		};
	},
	i18n: {
		messages: {
			en: {
				errorLoading: "There was an error loading the summary!",
				tryAgain: "Try again",
				loading: "Loading summary"
			},
			nl: {
				successTitle: "Bedankt!",
				successBody:
					"Eén van onze assetmanagement experts zal binnen drie werkdagen contact met je opnemen.",
				successButton: "Ga naar resultaten",
				loading: "Resultaten laden"
			}
		}
	},
	created() {
		this.fetchScores();
		this.$emit("setHeader", survey.categories.length + 1);
	},
	methods: {
		fetchScores() {
			this.error = undefined;
			fetch(`${process.env.API}/tenants/${store.getters.tenantName}/surveys/latest/score`, {
				method: "POST",
				headers: {
					Accept: "application/json, text/plain, */*",
					"Content-Type": "application/json"
				},
				credentials: "same-origin",
				body: JSON.stringify(survey.answers)
			})
				.then(stream => stream.json())
				.then(
					result => {
						survey.results = {
							additionalRecommendationCount:
								result.additional_recommendation_count,
							improvement: result.improvement,
							recommendation: result.recommendation
						};
						survey.token = result.token;
						survey.contactDetails = undefined;
						this.$router.replace({ name: "summary" });
					},
					error => {
						this.error = error;
					}
				);
		},
		reload() {
			this.fetchScores();
		}
	},
	beforeRouteEnter(to, from, next) {
		if (!survey.answers) {
			next({ name: "survey" });
		} else {
			next();
		}
	}
};
</script>

<style>
.survey__error-dialog {
	max-width: 800px;
}

.survey__error {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
}

.survey__error-button {
	margin-left: 10px;
}

@media only screen and (max-width: 767px) {
	.survey__error {
		display: flex;
		flex-direction: column;
	}

	.survey__error-button {
		margin: 10px 0 0 0;
	}
}
</style>
